import "./App.css";
import { collection, getDocsFromServer, limit, query } from "firebase/firestore";
import { db } from "./firebase";
import { Loading } from "./Components";
import {
  Login,
  MainLayout,
  Dashboard,
  MaintenanceRequests,
  TechnicianRequests,
  CleanerRequests,
  //Offer,
  Users,
  Villa,
  VisitorPermitis,
  BuildingDetails,
  // Building,
  UserProfile,
  ForgotPasssword,
  MaintenanceRequestsDetails,
  UserDetail,
  VillaDetails,
  VisitorPermitiDetails,
  OfferDetail,
  ApartmentAssign,
  VillaAssign,
    Projects,
} from "./pages";
import Offer from "./pages/Offer/Offer";
import Building from "./pages/Building/Building";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Suspense, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import toast from "react-hot-toast";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Support from "./pages/Support/Support";

// importing actions
import { generateGuestJWTStart } from "./store/Auth/actions";

// importing selectors
import {
  selectGuestTokenLoading,
  selectGuestTokenError,
  selectStaffuser,
  selectGuestToken,
} from "./store/Auth/selectors";
import Page404 from "./pages/Page404/Page404";

export function MaintenanceChatWarmup() {
  const staffUser = useSelector((state) => state.Auth.staffUser);
  const warmedUser = useRef(null);
  useEffect(() => {
    if (!staffUser?.id || !localStorage.getItem("userToken")) {
      warmedUser.current = null;
      return;
    }
    if (warmedUser.current === staffUser.id) return;

    // One attempt per signed-in app session; Firestore rules control read access.
    warmedUser.current = staffUser.id;
    const startedAt = performance.now();
    const warmChat = async () => {
      try {
        await getDocsFromServer(query(collection(db, "comments"), limit(1)));
        console.info("[Maintenance chat] Warm-up completed", {
          durationMs: Math.round(performance.now() - startedAt),
        });
      } catch (error) {
        console.warn("[Maintenance chat] Warm-up failed", { code: error?.code });
      }
    };
    void warmChat();
  }, [staffUser]);
  return null;
}

function App({
  // actions
  generateJWT,

  // selectors
  loadingGuestToken,
  guestTokenError,
  staffUser,
  guestToken,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("userToken")) generateJWT();
    if (!staffUser && (window.location.pathname !== '/privacy-policy' && window.location.pathname !== '/support')) navigate("/", { replace: true });
  }, []);
  // useEffect(() => {
  //   if (guestTokenError && guestTokenError.hasOwnProperty("message")) {
  //     const errorMessage =
  //       guestTokenError.message || JSON.stringify(guestTokenError);
  //     toast.error(errorMessage);
  //   }
  // }, [guestTokenError]);

  useEffect(() => {
    if (guestToken) toast.success("Welcome To ADAR Admin");
  }, [guestToken]);
  if (loadingGuestToken) return <Loading />;
  return (
    <>
      <MaintenanceChatWarmup />
      <Routes>

        <Route
          index
          element={
            <Suspense fallback={<>loading.....</>}>
              <Login />
            </Suspense>
          }
        ></Route>
        <Route
            path={"privacy-policy"}
            element={
              <PrivacyPolicy />
            }
        ></Route>
        <Route
            path={"support"}
            element={
              <Support />
            }
        ></Route>
      

        <Route element={<MainLayout />}>
          {
              (["admin", "sub_admin", "super_user", "project_manager"].includes(
                staffUser?.type
              ))
              &&
              (
                  <Route
                      exact
                      path={"/projects"}
                      element={
                        <Suspense fallback={<>loading.....</>}>
                          <Projects />
                        </Suspense>
                      }
                  />
              )
          }
          <Route
            path="dashboard"
            element={
              <Suspense fallback={<>loading.....</>}>
                <Dashboard />
              </Suspense>
            }
          />
        <Route
            path="forgot-password"
            element={
              <Suspense fallback={<>loading.....</>}>
                <ForgotPasssword />
              </Suspense>
            }
          />
         
          {(["admin", "sub_admin", "super_user"].includes(staffUser?.type)) && (
            <Route
              path="building"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <Building />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="building/:id"
              element={
                <Suspense fallback={<Loading />}>
                  <BuildingDetails />
                </Suspense>
              }
            />
          )}
          {(["admin", "sub_admin", "super_user"].includes(staffUser?.type)) && (
            <Route
              path="villa"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <Villa />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="villa/:id"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <VillaDetails />
                </Suspense>
              }
            />
          )}
          {(["admin", "sub_admin", "super_user"].includes(staffUser?.type)) && (
            <Route
              path="users"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <Users />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="users/:id"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <UserDetail />
                </Suspense>
              }
            />
          )}
          {(["admin", "sub_admin", "super_user"].includes(staffUser?.type)) && (
            <Route
              path="offer"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <Offer />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="offer/:id"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <OfferDetail />
                </Suspense>
              }
            />
          )}
          {(["admin", "sub_admin", "super_user", "security"].includes(staffUser?.type)) && (
            <Route
              path="visitorpermits"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <VisitorPermitis />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "security" || staffUser?.type === "sub_admin") && (
            <Route
              path="visitorpermit/:id"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <VisitorPermitiDetails />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" ||
            staffUser?.type === "sub_admin" ||
            staffUser?.type === "supervisor" ||
            staffUser?.type === "technician" ||
            staffUser?.type === "cleaner" ||
            staffUser?.type === "project_manager" ||
            staffUser?.type === "super_user") && (
            <Route
              path="maintenancerequests"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <MaintenanceRequests />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" ||
            staffUser?.type === "sub_admin" ||
            staffUser?.type === "supervisor" ||
            staffUser?.type === "technician" ||
            staffUser?.type === "cleaner" ||
            staffUser?.type === "project_manager" ||
            staffUser?.type === "super_user") && (
            <Route
              path="maintenancedetail/:id"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <MaintenanceRequestsDetails />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" ||
            staffUser?.type === "sub_admin" ||
            staffUser?.type === "technician") && (
            <Route
              path="technicianrequests"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <TechnicianRequests />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" ||
            staffUser?.type === "sub_admin" ||
            staffUser?.type === "cleaner") && (
            <Route
              path="cleanerrequests"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <CleanerRequests />
                </Suspense>
              }
            />
          )}
          <Route
            path="user-profile"
            element={
              <Suspense fallback={<>loading.....</>}>
                <UserProfile />
              </Suspense>
            }
          />
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="apartment/:id/assign"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <ApartmentAssign />
                </Suspense>
              }
            />
          )}
          {(staffUser?.type === "admin" || staffUser?.type === "sub_admin") && (
            <Route
              path="villa/:id/assign"
              element={
                <Suspense fallback={<>loading.....</>}>
                  <VillaAssign />
                </Suspense>
              }
            />
          )}

          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
      <ToastContainer
        autoClose={3000}
        closeButton={true}
        closeOnClick={false}
        draggable={false}
      />
    </>
  );
}

const mapState = (state) => ({
  loadingGuestToken: selectGuestTokenLoading(state),
  guestTokenError: selectGuestTokenError(state),
  staffUser: selectStaffuser(state),
  guestToken: selectGuestToken(state),
});
const mapDispatch = (dispatch) => ({
  generateJWT: () => dispatch(generateGuestJWTStart()),
});

export default connect(mapState, mapDispatch)(App);
